import React from 'react';
import {Link} from "react-router-dom";
import ChevronBlueIcon from "assets/images/svg/chevron_right_blue.svg"
import { useTranslation } from 'react-i18next';

interface Props {
    children: React.ReactNode,
    title: string,
    count: any,
    link: string,
}

function Section({children, title, count, link}: Props) {
    const { t } = useTranslation("home");

    return (
        <div className='box'>
            <div className='header'>
                <h2>{title} <span>({count})</span></h2>
                <Link to={link}>{t("viewAll")} <img src={ChevronBlueIcon} alt="link"/></Link>
            </div>
            {children}
        </div>
    );
}

export default Section;